import type { IModuleDefinition, IModulePage, IModuleStrings } from '@platform/core/types';

/** Стандартні сторінки модуля, які рушій рендерить для будь-якого модуля (у порядку меню). */
export const standardPages: readonly string[] = ['overview', 'advisory', 'analytics', 'help'];

export function isStandardPage(key: string): boolean {
  return standardPages.includes(key);
}

/** Сторінки модуля з визначення; без них — чотири стандартні (підписи дає платформа). */
export function modulePagesOf(definition: IModuleDefinition): IModulePage[] {
  const pages = definition.pages ?? [];
  if (pages.length) return pages;
  return standardPages.map((key): IModulePage => ({ key, label: { en: key }, kind: 'standard' }));
}

/**
 * Підпис сторінки: рядок пакета `pages[ключ]` → для стандартних сторінок платформний підпис (i18n рушія),
 * для аналітичних подань (insight) — підпис визначення мовою інтерфейсу → ключ.
 */
export function pageLabel(page: IModulePage, strings: IModuleStrings, platformLabel: (key: string) => string): string {
  return page.kind === 'standard' ? strings.page(page.key, platformLabel(page.key)) : strings.page(page.key, page.label);
}

/** Аналітичне подання модуля (insight) за ключем сторінки. */
export function insightPageOf(definition: IModuleDefinition, key: string | undefined): IModulePage | undefined {
  return key ? modulePagesOf(definition).find((p) => p.key === key && p.kind === 'insight') : undefined;
}
